export default __webpack_public_path__ + "static/media/16_justin_holdon.5ea410ea.png";